export default __webpack_public_path__ + "static/media/group-5907.46b51ed2.png";